import React, { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CircleChevronDown, CircleChevronRight } from "lucide-react";
// cSpell: ignore Subramaniam

const services = [
  {
    title: "Construction Loans",
    description: `At Subramaniam Financial Services, we understand that a home is more than just a building. It's a lifelong dream. Our range of home loan solutions is designed to support you at every stage of your journey, whether you're building from scratch, buying a ready-made property, or upgrading your existing home.`,
  },
  {
    title: "Tractor Loans",
    description: `At Subramaniam Financial Services, we offer specialized loan solutions for used commercial vehicles such as trucks, vans, and other transport vehicles. Our financing options are designed to help business owners expand or upgrade their fleet without straining their working capital. With minimal documentation, quick approvals, and flexible repayment terms, we make it easy for you to invest in reliable pre-owned vehicles that support your operational needs.`,
  },
  {
    title: "Loans for Salaried",
    description: `Designed specifically for working professionals, our salaried personal loans offer quick approval and fixed EMIs with no collateral required. Whether you're planning a family event or facing an emergency, we help you manage your expenses effortlessly. Simple documentation and transparent terms make the borrowing experience smooth and stress-free.`,
  },
  // {
  //   title: "Life Insurance",
  //   description: `Secure your family’s future with our trusted Life Insurance plans. Whether it’s term insurance, whole life, or endowment policies, we offer tailored solutions to ensure financial protection, peace of mind, and long-term savings for your loved ones in the event of any uncertainties.`,
  // },
  {
    title: "Affordable Education Loans",
    description: `Subramaniam Financial Services offers Affordable Education Loans to help students pursue their academic dreams without financial stress. Our loans cover tuition fees, living expenses, travel, and more whether you're studying in India or abroad. With competitive interest rates, flexible repayment options, and minimal paperwork, we ensure a smooth loan process. We are committed to making quality education accessible for every deserving student. Begin your educational journey with confidence, backed by the trusted support of Subramaniam Financial Services.`,
  },
];

const ServiceCard = ({ index, title, description, isExpanded, onToggle }) => {
  const cardRef = useRef();
  const isInView = useInView(cardRef);

  const words = description.split(" ");
  const shortDesc =
    words.slice(0, 25).join(" ") + (words.length > 25 ? "..." : "");

  return (
    <motion.div
      ref={cardRef}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ delay: index * 0.1, duration: 0.6, ease: "easeOut" }}
      className="border bg-white border-gray-300 rounded-xl shadow-sm"
    >
      <div className="flex justify-between items-center p-6">
        <div className="flex-1 pr-4">
          <div className="flex justify-between items-center">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2 flex items-center">
              <span className="text-blue-700 font-bold mr-2">{`0${
                index + 1
              }.`}</span>
              {title}
            </h3>
            <motion.button
              onClick={onToggle}
              className={`w-10 h-10 rounded-full flex items-center justify-center transition ${
                isExpanded
                  ? "bg-blue-700 hover:bg-blue-800"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
              whileTap={{ scale: 0.9 }}
            >
              {isExpanded ? (
                <CircleChevronDown className="text-white w-6 h-6" />
              ) : (
                <CircleChevronRight className="text-blue-700 w-6 h-6" />
              )}
            </motion.button>
          </div>
          <AnimatePresence mode="wait">
            <motion.p
              key={isExpanded ? "expanded" : "collapsed"}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.4 }}
              className="text-gray-600 text-base overflow-hidden px-9"
            >
              {isExpanded ? description : shortDesc}
            </motion.p>
          </AnimatePresence>
        </div>
      </div>
    </motion.div>
  );
};

const useInView = (ref, threshold = 0.2) => {
  const [isInView, setIsInView] = React.useState(false);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, threshold]);

  return isInView;
};

const OurServices = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  return (
    <div className="container mx-auto px-4 mb-4" id="our-services">
      <div className=" bg-gradient-to-b rounded-lg from-[#d6f0ff] via-[#f0faff] to-white px-4 py-10">
        <h6 className="text-3xl md:text-4xl font-extrabold text-center mb-10 text-gray-900">
          Our Services
        </h6>

        <div className="space-y-6 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              index={index}
              title={service.title}
              description={service.description}
              isExpanded={expandedIndex === index}
              onToggle={() =>
                setExpandedIndex(expandedIndex === index ? null : index)
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurServices;
